import { OrderButton } from "@omni/components/components/Product/ECommerce/components/orderButton/orderButton";

type Props = {};

export const OrderButtonComponent = ({ ...attributes }: Props) => {
    return (
        <OrderButton.Button
            color={"primary"}
            fullWidth={true}
            {...attributes}
        />
    );
};
